import { TMasterdataSyncStatus } from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum InputAppMetadataActionTypes {
  UpdateOnlineStatus = '[METADATA] UpdateOnlineStatus',
  UpdateHealthCheckStatus = '[METADATA] UpdateHealthCheckStatus',
  FetchHealthCheckStatusAndUpdate = '[] FetchHealthCheckStatusAndUpdate',
  InitSyncingStatus = 'InitSyncingStatus',
  ClearSyncingStatus = 'ClearSyncingStatus',
  UpdateSyncingStatus = 'UpdateSyncingStatus',
  UpdateBulkSyncingStatus = 'UpdateBulkSyncingStatus',
  InitialiseScanner = 'InitialiseScanner',
}

export class UpdateOnlineStatus implements Action {
  readonly type = InputAppMetadataActionTypes.UpdateOnlineStatus;
  constructor(public status: boolean) {}
}
export class UpdateHealthCheckStatus implements Action {
  readonly type = InputAppMetadataActionTypes.UpdateHealthCheckStatus;
  constructor(public status: boolean) {}
}

export class FetchHealthCheckStatusAndUpdate implements Action {
  readonly type = InputAppMetadataActionTypes.FetchHealthCheckStatusAndUpdate;
  constructor() {}
}

export class InitSyncingStatus implements Action {
  readonly type = InputAppMetadataActionTypes.InitSyncingStatus;
  constructor(public keys: string[]) {}
}

export class ClearSyncingStatus implements Action {
  readonly type = InputAppMetadataActionTypes.ClearSyncingStatus;
  constructor() {}
}

export class UpdateSyncingStatus implements Action {
  readonly type = InputAppMetadataActionTypes.UpdateSyncingStatus;
  constructor(public key: string, public status: TMasterdataSyncStatus) {}
}

export class UpdateBulkSyncingStatus implements Action {
  readonly type = InputAppMetadataActionTypes.UpdateBulkSyncingStatus;
  constructor(public keys: string[], public status: TMasterdataSyncStatus) {}
}

export class InitialiseScanner implements Action {
  readonly type = InputAppMetadataActionTypes.InitialiseScanner;
  constructor(public isInitialised: boolean) {}
}

export type TInputAppMetadataActions =
  | UpdateOnlineStatus
  | UpdateHealthCheckStatus
  | FetchHealthCheckStatusAndUpdate
  | InitSyncingStatus
  | ClearSyncingStatus
  | UpdateSyncingStatus
  | UpdateBulkSyncingStatus
  | InitialiseScanner;
